<template>
  <div
    style="
      width: 100%;
      height: 100%;
      background: rgb(0, 0, 0, 0.5);
      padding: 40px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
    "
    class="transition-box"
    @contextmenu.prevent.enter="close"
  >
    <div
      style="
        width: calc(100% - 80px);
        height: calc(100% - 80px);
        background-color: #fff;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        border: 0.1px solid #1779de;
        position: absolute;
      "
      :style="{ left: state.x + 'px', top: state.y + 'px' }"
      @click.stop=""
      @contextmenu.prevent.stop=""
      @mousedown="startDrag"
    >
      <ul
        style="
          height: 30px;
          background: #1a8bfd;
          padding: 0 10px;
          font-size: 14px;
          line-height: 30px;
          color: #fff;
          display: flex;
          align-items: center;
        "
      >
        <li style="flex: 1">
          {{ state?.title }}
        </li>
        <li class="closeIcon">
          <el-icon style="color: #fff" size="18" @click="close()"
            ><Close
          /></el-icon>
        </li>
      </ul>
      <ul style="flex: 1; overflow: hidden" @mousedown.stop="">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, watch } from "vue";
export default {
  props: {
    title: String,
  },
  setup(props, { emit }) {
    const state = reactive({
      x: 40,
      y: 40,
    });
    onMounted(() => {
      state.title = props.title;
    });

    watch(
      () => props.title,
      (value) => {
        state.title = value;
      },
    );

    const close = () => {
      emit("close");
    };

    // 记录鼠标与盒子的偏移量
    let offsetX = 0;
    let offsetY = 0;

    // 开始拖动
    const startDrag = (e) => {
      //计算鼠标相对于盒子左上角的偏移;
      offsetX = e.clientX - state.x;
      offsetY = e.clientY - state.y;

      // 监听移动和松开
      document.addEventListener("mousemove", onDrag);
      document.addEventListener("mouseup", stopDrag);
    };

    // 拖动中
    const onDrag = (e) => {
      state.x = e.clientX - offsetX;
      state.y = e.clientY - offsetY;
    };

    // 停止拖动
    const stopDrag = () => {
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("mouseup", stopDrag);
    };

    return { state, close, startDrag };
  },
};
</script>
<style scoped>
.closeIcon {
  display: flex;
  align-items: center;
}

.closeIcon .el-icon {
  cursor: pointer;
  margin-left: 5px;
}
.closeIcon .el-icon:hover {
  transform: scale(1.3);
}
</style>
